import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {NgxGalleryComponent, NgxGalleryImage, NgxGalleryOptions} from "ngx-image-video-gallery";

@Component({
  selector: 'app-video-image-gallery',
  templateUrl: './video-image-gallery.component.html',
  styleUrls: ['./video-image-gallery.component.scss']
})
export class VideoImageGalleryComponent implements OnInit {

  @Input('items') set _items(value: { path: string }[]) {
    this.items = value.map(el => {
      return {small: el.path, big: el.path, medium: el.path}
    });
  }

  @ViewChild(NgxGalleryComponent, {static: false}) private ngxGalleryComponentInstance: NgxGalleryComponent;

  public items: NgxGalleryImage[];
  public readonly galleryOptions: NgxGalleryOptions[] = [
    {
      preview: false,
      thumbnails: false,
      image: false,
      width: '0px',
      height: '0px',
    }
  ];

  constructor() {
  }

  ngOnInit() {
  }

  public openPreview(index = 0) {
    this.ngxGalleryComponentInstance.openPreview(index);
  }

}
